(function() {
  'use strict';

  /* wnf-cart-drawer-2026-10-03: "Complete the room" strip for the redesigned cart drawer (snippets/cart-drawer.liquid,
     mount #wcdXsell). The free-delivery meter moved to snippets/wnf-delivery-meter.liquid (server-rendered with the
     cart), so this file no longer touches delivery copy.
     Picks come from sections/cart-extras-data.liquid (first 4 available per collection), matched on the newest piece
     of furniture in the cart. One-tap Add only for single-variant products; anything with options links to its page
     so we never guess a color or size for the shopper. */
  if (window.__wnfCartExtras) return;
  window.__wnfCartExtras = true;

  var LIMIT = 6;

  /* Product type keyword -> complementary collection handles, most relevant first. Checked via indexOf against the
     lowercase product type (and title), longest key first so "dining table" matches before "table".
     wnf-cart-drawer-2026-10-03: furniture anchors suggest furniture, rugs and lighting; decor and art stay for small-item
     anchors (a $30 seasonal decor piece next to a sofa read as noise). */
  var LIVING = ['coffee-tables', 'side-tables', 'vintage-modern-rugs-portland', 'lighting'];
  var CHAIR = ['side-tables', 'vintage-modern-rugs-portland', 'lighting', 'coffee-tables'];
  var BEDROOM = ['nightstands-portland', 'dressers-portland', 'vintage-modern-rugs-portland', 'lighting'];
  var DINING_T = ['dining-chairs-portland', 'lighting', 'vintage-modern-rugs-portland'];
  var DINING_C = ['dining-tables-portland', 'lighting', 'vintage-modern-rugs-portland'];
  var CASE = ['lighting', 'vintage-modern-rugs-portland', 'decor', 'art', 'side-tables'];
  var SMALL = ['vintage-modern-rugs-portland', 'lighting', 'decor', 'art', 'side-tables', 'coffee-tables'];
  var COMP_MAP = {
    'sofa': LIVING, 'sectional': LIVING, 'loveseat': LIVING, 'sleeper': LIVING, 'chaise': LIVING,
    'recliner': CHAIR, 'swivel': CHAIR, 'accent': CHAIR, 'chair': CHAIR, 'ottoman': CHAIR, 'bench': CHAIR,
    'bed': BEDROOM, 'headboard': BEDROOM, 'daybed': BEDROOM,
    'mattress': ['beds-headboards-portland', 'nightstands-portland', 'dressers-portland', 'lighting'],
    'nightstand': ['beds-headboards-portland', 'dressers-portland', 'lighting', 'vintage-modern-rugs-portland'],
    'dresser': ['beds-headboards-portland', 'nightstands-portland', 'lighting', 'vintage-modern-rugs-portland'],
    'dining table': DINING_T, 'dining chair': DINING_C, 'bar stool': DINING_C, 'counter stool': DINING_C, 'stool': DINING_C,
    'coffee table': ['sofas', 'side-tables', 'vintage-modern-rugs-portland', 'lighting'],
    'side table': ['lighting', 'coffee-tables', 'vintage-modern-rugs-portland', 'decor'],
    'end table': ['lighting', 'coffee-tables', 'vintage-modern-rugs-portland', 'decor'],
    'desk': ['office-chairs-portland', 'lighting', 'bookcases', 'vintage-modern-rugs-portland'],
    'office': ['lighting', 'bookcases', 'vintage-modern-rugs-portland', 'decor'],
    'console': CASE, 'sideboard': CASE, 'media': CASE, 'bookcase': CASE, 'cabinet': CASE, 'credenza': CASE,
    'rug': ['coffee-tables', 'sofas', 'side-tables', 'lighting'],
    'decor': SMALL, 'art': SMALL, 'mirror': SMALL, 'lighting': SMALL, 'lamp': SMALL, 'pillow': SMALL, 'throw': SMALL
  };

  var DEFAULT_COMP = ['coffee-tables', 'side-tables', 'vintage-modern-rugs-portland', 'lighting'];

  /* Pre-sort map keys by length descending so "dining table" matches before "table" */
  var COMP_KEYS = Object.keys(COMP_MAP).sort(function(a, b) { return b.length - a.length; });

  var mount = document.getElementById('wcdXsell');
  if (!mount) return;

  /* =========================================
     COMPLEMENTARY PRODUCT DATA (lazy, once)
     ========================================= */
  var compData = null;
  var compDataPending = null;
  function ensureCompData(cb) {
    if (compData) { cb(); return; }
    if (compDataPending) { compDataPending.push(cb); return; }
    compDataPending = [cb];
    fetch('/?section_id=cart-extras-data', { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var mm = html.match(/<script[^>]*id="cdComplementaryProducts"[^>]*>([\s\S]*?)<\/script>/);
        try { compData = mm ? JSON.parse(mm[1]) : {}; } catch (e) { compData = {}; }
      })
      .catch(function() { compData = {}; })
      .then(function() {
        var cbs = compDataPending; compDataPending = null;
        cbs.forEach(function(fn) { fn(); });
      });
  }

  function isMerch(item) {
    var t = (item.product_type || '').toLowerCase();
    if ((item.sku || '').indexOf('DELIV-') === 0 || item.requires_shipping === false || item.gift_card) return false;
    return !(t.indexOf('service') > -1 || t.indexOf('delivery') > -1 || t.indexOf('protection') > -1);
  }

  function anchorItem(items) {
    for (var i = items.length - 1; i >= 0; i--) { if (isMerch(items[i])) return items[i]; }
    return null;
  }

  function collectionsFor(item) {
    if (!item) return DEFAULT_COMP;
    var pt = (item.product_type || '').toLowerCase();
    var title = (item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('nectar') !== -1) return COMP_MAP['mattress'];
    for (var i = 0; i < COMP_KEYS.length; i++) {
      if (pt.indexOf(COMP_KEYS[i]) !== -1 || title.indexOf(COMP_KEYS[i]) !== -1) return COMP_MAP[COMP_KEYS[i]];
    }
    return DEFAULT_COMP;
  }

  function pick(items) {
    var inCart = items.map(function(it) { return it.product_id; });
    var handles = collectionsFor(anchorItem(items));
    var out = [], seen = {};
    function take(p) {
      if (out.length >= LIMIT || seen[p.id] || inCart.indexOf(p.id) !== -1) return false;
      seen[p.id] = true; out.push(p); return true;
    }
    /* round-robin across the matched collections, most relevant first, so no single category fills the strip */
    for (var round = 0; round < 4 && out.length < LIMIT; round++) {
      handles.forEach(function(h) { var p = (compData[h] || [])[round]; if (p) take(p); });
    }
    return out;
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function render(items) {
    var merch = (items || []).filter(isMerch);
    if (!merch.length) { mount.innerHTML = ''; return; }
    if (!compData) { ensureCompData(function() { render(items); }); return; }
    var picks = pick(items);
    if (!picks.length) { mount.innerHTML = ''; return; }
    var html = picks.map(function(p) {
      var img = (p.image || '').replace(/([?&])width=\d+/, '$1width=320');
      var single = p.variants === 1;
      return '<li class="wcd-xs__item">' +
        '<a class="wcd-xs__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="160" height="160">' : '') +
        '</a>' +
        '<div class="wcd-xs__body">' +
          '<a class="wcd-xs__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="wcd-xs__price">' + money(p.price) + '</span>' +
          (single
            ? '<button type="button" class="wcd-xs__btn" data-wcd-xs-add="' + esc(p.variantId) + '" aria-label="Add ' + esc(p.title) + ' to your cart">Add</button>'
            : '<a class="wcd-xs__btn" href="' + esc(p.url) + '" aria-label="See options for ' + esc(p.title) + '">See options</a>') +
        '</div></li>';
    }).join('');
    mount.innerHTML = '<section class="wcd-xs" aria-labelledby="wcdXsTitle"><h3 class="wcd-xs__title" id="wcdXsTitle">Complete the room</h3>' +
      '<ul class="wcd-xs__list" role="list">' + html + '</ul></section>';
  }

  /* =========================================
     ADD (single-variant picks only)
     ========================================= */
  mount.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-wcd-xs-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-wcd-xs-add'), 10);
    if (!id) return;
    btn.disabled = true;
    /* Next tick: Motion's drawer closes on a click whose target has left the drawer. */
    setTimeout(function() { if (btn.disabled) btn.textContent = 'Adding'; }, 0);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function(r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function() {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:build'));
        refresh();
      })
      .catch(function() { btn.disabled = false; btn.textContent = 'Add'; });
  });

  /* =========================================
     CART DATA
     ========================================= */
  var timer = null;
  function refresh() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function() {
      timer = null;
      fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { render(cart.items); })
        .catch(function() {});
    }, 120);
  }

  document.addEventListener('cart:updated', function(evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart && cart.items) render(cart.items); else refresh();
  });
  ['ajaxProduct:added', 'cart:open', 'drawerOpen.CartDrawer'].forEach(function(name) { document.addEventListener(name, refresh); });
  refresh();
})();
